import { jsx as e } from "react/jsx-runtime";
import { useContext as n } from "react";
import { DimensionsProvider as t, DimensionsContext as r } from "./Dimensions.js";
import s from "./useWindowSizeEffect.js";
function p({ children: o }) {
  const { width: i } = s();
  return /* @__PURE__ */ e(t, { width: i, children: o });
}
const c = () => n(r);
export {
  p as default,
  c as useWindowSize
};
